(function () {

    // Bootstrap scripts
    const Bs = require("../_includes/bs.js");
    document.addEventListener("DOMContentLoaded", () => {
        let bs = new Bs();
        bs.runAll();
    });

    document.addEventListener('DOMContentLoaded', function (e) {
        document.querySelectorAll('.larativo-form-birthday').forEach(item => {
            item.addEventListener('keydown', (event) => {
                var charCode = (event.which) ? event.which : event.keyCode
                if ((charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
                    var dateBox = event.target;
                    var chars = dateBox.value.length;
                    var text = dateBox.value;

                    if (chars == 2) {
                        dateBox.value = text + ".";
                    }
                    if (chars == 5) {
                        dateBox.value = text + ".";
                    }
                }
                else if (charCode == 37 || charCode == 39 || charCode == 46 || charCode == 8) { }
                else {
                    event.preventDefault();
                }
            })
        });
    });
})();
